import React, { ReactNode } from 'react';
import { Card } from './Card';
import { Diff } from '../Diff';
import { getDiff, getComparePresetLabel } from '../../model/Diff';
import { ComparePreset } from '../../model/datePicker/types';

const ValueCard = ({ title, value, previousValue, format, color, icon, comparePreset }: Props) => {
  return (
    <Card className={`card-border-shadow-${color}`}>
      <div className="card-body">
        <div className="d-flex align-items-center">
          {icon}
          <h4 className="flex-grow-1 ms-3 mb-0">{format ? format(value) : value}</h4>
        </div>
        <div className="mb-2 mt-3">{title}</div>
        <small className="d-flex align-items-center">
          <Diff value={getDiff(value, previousValue)} />
          <div className="text-muted">{getComparePresetLabel(comparePreset)} ({format ? format(previousValue) : previousValue})</div>
        </small>
      </div>
    </Card>);
}

interface Props {
  title: string,
  value: number,
  previousValue: number,
  color: string,
  format?: (value: number) => string,
  icon: ReactNode,
  comparePreset?: ComparePreset
}

export { ValueCard };